import { BaseProvider } from "./base.provider";
import { jsonParser } from "../utilities/parsers";
import { event } from "../utilities/event-listeners";
export class KironProvider extends BaseProvider {
    messageHandler(e, launchData) {
        const { clientScriptData } = launchData;
        const clientScripts = jsonParser(clientScriptData);
        console.log({ clientScripts });
        if (typeof e.data !== "undefined" && e.data.command === "adjustiframe") {
            window.dispatchEvent(event({
                detail: { height: parseInt(e.data.value.replace("px", "")) },
            }));
        }
    }
    init() {
        const { clientScriptData } = this.launchData;
        this.clientSciptData = jsonParser(clientScriptData);
        document.domain = this.clientSciptData.operatorDomain;
        window.addEventListener("message", (e) => this.messageHandler(e, this.launchData), true);
        window.addEventListener("beforeunload", () => {
            window.removeEventListener("message", (e) => this.messageHandler(e, this.launchData), true);
        });
    }
}
